import {
    ReactNode,
    useCallback,
    useEffect,
    useState,
} from 'react';
import {
    fetchUserAttributes,
    signOut
} from 'aws-amplify/auth';
import {UserAttributesContext} from '../context/UserAttributesContext.tsx';
import {useAuth} from "../hooks/useAuth.ts";


type UserAttributesProviderProps = {
    children?: ReactNode;
}

export const UserAttributesProvider = (
    {
        children,
    }: UserAttributesProviderProps) => {

    const {user} = useAuth()

    const [attributes, setAttributes] = useState<Partial<Record<string, string>>>({})


    const [sub, setSub] = useState('')
    const [zoneInfo, setZoneInfo] = useState('')
    const [website, setWebsite] = useState('')
    const [address, setAddress] = useState('')
    const [emailVerified, setEmailVerified] = useState(false)
    const [profile, setProfile] = useState('')
    const [accountAdmin, setAccountAdmin] = useState(false)
    const [locale, setLocale] = useState('')
    const [givenName, setGivenName] = useState('')
    const [picture, setPicture] = useState('')
    const [name, setName] = useState('')
    const [nickname, setNickName] = useState('')
    const [accountId, setAccountId] = useState('')
    const [familyName, setFamilyName] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [middleName, setMiddleName] = useState('')
    const [birthdate, setBirthdate] = useState('')
    const [gender, setGender] = useState('')


    const fetchAttributes = useCallback(async () => {

        try {
            const attr = await fetchUserAttributes();
            setAttributes(attr)
        } catch (e: unknown) {
            if (e instanceof Error) {
                switch (e.name) {
                    case 'NotAuthorizedException':
                        console.debug('Message', e.message)
                        if (e.message.includes('Token is inactive')) {
                            await signOut()
                            window.location.href = '/';
                        }
                        break
                }
            }
        }


    }, [])

    useEffect(() => {
        fetchAttributes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])


    useEffect(() => {

        if (!Array.isArray(Object.keys(attributes)) || Object.keys(attributes).length === 0) {
            return;
        }

        Object.keys(attributes)
              .forEach((key: string) => {

                  switch (key) {
                      case 'sub':
                          setSub(attributes[key] ?? '')
                          break;
                      case 'zoneinfo':
                          setZoneInfo(attributes[key] ?? '')
                          break;
                      case 'website':
                          setWebsite(attributes[key] ?? '')
                          break;
                      case 'address':
                          setAddress(attributes[key] ?? '')
                          break;
                      case 'email_verified':
                          setEmailVerified(attributes[key] === 'true')
                          break;
                      case 'profile':
                          setProfile(attributes[key] ?? '')
                          break;
                      case 'custom:account_admin':
                          setAccountAdmin(attributes[key] === 'true')
                          break;
                      case 'locale':
                          setLocale(attributes[key] ?? '')
                          break;
                      case 'given_name':
                          setGivenName(attributes[key] ?? '')
                          break;
                      case 'picture':
                          setPicture(attributes[key] ?? '')
                          break;
                      case 'name':
                          setName(attributes[key] ?? '')
                          break;
                      case 'nickname':
                          setNickName(attributes[key] ?? '')
                          break;
                      case 'custom:account_id':
                          setAccountId(attributes[key] ?? '')
                          break;
                      case 'family_name':
                          setFamilyName(attributes[key] ?? '')
                          break;
                      case 'email':
                          setEmail(attributes[key] ?? '')
                          break;
                      case 'phone_number':
                          setPhoneNumber(attributes[key] ?? '')
                          break;
                      case 'middle_name':
                          setMiddleName(attributes[key] ?? '')
                          break;
                      case 'birthdate':
                          setBirthdate(attributes[key] ?? '')
                          break;
                      case 'gender':
                          setGender(attributes[key] ?? '')
                          break;
                  }
              })


    }, [attributes])


    return (
        <UserAttributesContext.Provider
            value={{
                sub,
                zoneInfo,
                website,
                address,
                emailVerified,
                profile,
                accountAdmin,
                locale,
                givenName,
                picture,
                name,
                nickname,
                accountId,
                familyName,
                email,
                phoneNumber,
                middleName,
                birthdate,
                gender
            }}
        >
            {children}
        </UserAttributesContext.Provider>
    );
};
